import Color from 'color';
import { Link } from 'gatsby';
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next';

import UTIcon from '../../components/icons';
import Searcher from '../../components/searcher';
import { usePartnerContext } from '../../context/partner';
import { IFullTopic, IFullModule, useCourseContext } from '../../context/course';

const COURSE_SEARCH_TOOGLE = true;

export default function Search() {

    const { course } = useCourseContext();
    const { t } = useTranslation();
    const { colors } = usePartnerContext();

    const [search, setSearch] = React.useState("");

    // the search sits in the header (secondary / secondaryText), so every
    // colour here is derived from secondaryText: a faint fill, a faint
    // border, and the text itself
    const ink = Color(colors?.secondaryText || "#000");
    const fieldStyle = {
        color: ink.hex(),
        borderColor: ink.alpha(0.35).string(),
        backgroundColor: ink.alpha(0.08).string(),
    };

    const searchItems = useMemo(() => {

        if (search === "") return [];

        if (!course) return [];

        const modules = (course?.modules.map((m: IFullModule) => (
            {
                ...m,
                url: `/classroom/${course.slug}/${m.slug}`
            }
        )) || []);

        const topics = modules.map((m) => m.topics.map((mt: IFullTopic) => ({
            ...mt,
            url: `/classroom/${course.slug}/${m.slug}/${mt.slug}`
        }))).flat();

        const subtopics: any[] = topics.map((t) => t.subTopics.map((st) => ({
            ...st,
            url: `${t.url}/${st.slug}`
        })).flat()).flat();

        const items: (Partial<{
            name: string;
            url: string;
        }>[]) = [
                ...modules,
                ...topics,
                ...subtopics
            ];

        return items.filter((item) => {
            return item.name?.toLowerCase().includes(search.toLowerCase());
        }).splice(0, 8);

    }, [search]);

    if (!course || !COURSE_SEARCH_TOOGLE) return <></>;

    return (<div className={"relative"}>
        <div
            className={"pointer-events-none absolute inset-y-0 left-3 flex items-center"}
            style={{ color: ink.alpha(0.7).string() }}
            aria-hidden
        >
            <UTIcon type={"search"} size={14} color={ink.alpha(0.7).string()} />
        </div>
        <Searcher
            key={"HeaderSearcher"}
            value={search}
            placeholder={t("search.placeholder")}
            className={`
                text-sm w-full md:w-[260px] rounded-md border
                py-2 pl-9 pr-4
                transition-all duration-150
                placeholder:opacity-70
                focus:outline-none focus:ring-2 focus:ring-offset-0
            `}
            style={{
                ...fieldStyle,
                ["--tw-ring-color" as any]: ink.alpha(0.4).string(),
            }}
            onChange={(q) => { setSearch(q) }}
        />
        {searchItems.length > 0 && <div className={"absolute top-full left-0 w-full md:w-[260px] bg-white text-black rounded-md shadow-lg border mt-1 z-50 overflow-hidden"}>
            {searchItems.map((item, index) => {
                return (
                    <Link key={item.name} to={item.url || "/404"} className={"block py-2 px-4 hover:bg-gray-100"}
                        onClick={() => { setSearch("") }}
                    >
                        {item.name}
                    </Link>
                )
            })}
        </div>}
    </div>
    )
}
